@import ../../styles/helpers

.photo
    width: $icon_size
    height: $icon_size
    border-radius: 100px
    &.bc1
        background-color: #1A7BD9
    &.bc2
        background-color: #1A7BD9
    &.bc3
        background-color: blue
    &.bc4
        background-color: purple
    &.bc5
        background-color: yellow
    +m
        width: $icon_size_m
        height: $icon_size_m

.avatarContainer
    position: relative

.status
    display: none
    width: 14px
    height: 14px
    
    border: 2px solid $page_background
    border-radius: 50%
    justify-content: center
    align-items: center
    display: flex
    position: absolute
    bottom: 0
    right: 0
    transform: translate(2px,2px)
    &.active
        background-color: $sucess_color
